import { Boxes, Home, Truck, Warehouse } from "lucide-react";
import Reveal from "@/components/Reveal";

const services = [
  {
    id: "residential",
    number: "01",
    title: "Entrümpelungen",
    description: "Für Räume, die wieder frei und übersichtlich werden sollen.",
    items: ["Wohnungen", "Keller", "Dachböden / Speicher", "Garagen", "Lagerräume", "Einzelne Zimmer"],
    Icon: Boxes,
  },
  {
    id: "household",
    number: "02",
    title: "Haushaltsauflösungen",
    description: "Komplett, teilweise oder als gezielte Wohnungsräumung – persönlich besprochen.",
    items: ["Komplette Haushaltsauflösungen", "Teilweise Haushaltsauflösungen", "Wohnungsräumungen"],
    Icon: Home,
  },
  {
    id: "moving",
    number: "03",
    title: "Umzüge & Transporte",
    description: "Unterstützung, wenn nicht der große Umzug, sondern genau der nächste Schritt zählt.",
    items: ["Kleinere Umzüge", "Seniorenumzüge", "Heimwechsel", "Transporte", "Möbeltransporte"],
    Icon: Truck,
  },
  {
    id: "other",
    number: "04",
    title: "Weitere Räumungen",
    description: "Auch kleinere und individuelle Aufträge gehören zu unserem Alltag.",
    items: ["Keller", "Speicher", "Garagen", "Außenlager", "Kleinere Gewerberäume"],
    Icon: Warehouse,
  },
];

export default function ServicesSection() {
  return (
    <section className="section section-light services-section" id="leistungen" data-testid="services-bento-container">
      <div className="container">
        <Reveal className="section-heading-row">
          <div className="section-index dark-index">02 / 05</div>
          <div>
            <span className="eyebrow dark-eyebrow">Leistungen</span>
            <h2 className="section-title dark-title">Was gebraucht wird,<br /><em>wird möglich gemacht.</em></h2>
            <p className="section-lead dark-lead">Von der einzelnen Ecke bis zur kompletten Wohnung: Wir schauen auf den tatsächlichen Bedarf – nicht auf eine Mindestgröße.</p>
          </div>
        </Reveal>
        <div className="services-grid">
          {services.map(({ id, number, title, description, items, Icon }, index) => (
            <Reveal key={id} className={`service-card service-card-${id}`} delay={index * 70}>
              <article data-testid={`service-card-${id}`}>
                <div className="service-card-top">
                  <span className="service-number">{number}</span>
                  <Icon className="service-icon" size={28} strokeWidth={1.25} />
                </div>
                <h3>{title}</h3>
                <p>{description}</p>
                <ul>
                  {items.map((item) => <li key={item}>{item}</li>)}
                </ul>
              </article>
            </Reveal>
          ))}
        </div>
        <Reveal className="service-note" delay={180}>
          <span className="note-line" />
          <p><strong>Auch kleinere Aufträge sind willkommen.</strong> Ein einzelnes Zimmer, ein Keller, wenige Möbel oder ein Umzug in ein Pflegeheim – schildern Sie uns einfach, was ansteht.</p>
        </Reveal>
      </div>
    </section>
  );
}
